import { Field } from 'formik';
import { MuiColorInput } from 'mui-color-input';
import React from 'react';

const ColorPicker = ({ name, setThemeColor }) => {
  return (
    <Field name={name}>
      {({ field, form }) => (
        <MuiColorInput
          format="hex"
          value={field.value || ''}
          variant="standard"
          label="Standaard stijl instellen voor apps"
          onChange={color => {
            setThemeColor(color);
            form.setFieldValue(name, color);
          }}
          isAlphaHidden
        />
      )}
    </Field>
  );
};

export default ColorPicker;
